module.exports = __webpack_public_path__ + "assets/img/sukikamo_list_fukidashi_sp.ec133466.svg";